<div [ngClass]="{ 'Insurance-border-green': haveInsurance, 'Insurance-border-red': !haveInsurance }">
  <h3 mat-dialog-title>
    @if(product.Title.startsWith('Turbo.')) {
    <span>{{ product.Title | translate: 'Insurance' }}</span>
    } @else {
    <span>{{ product.Title }}</span>
    }
  </h3>

  @if (product.Id === 1004 || product.Id === 901) {
  <div>
    <p class="text-center">
      @if (haveInsurance) {
      {{ 'Intellitrailer.Booking.UnConfirmedBooking.Price' | translate: 'Price:' }}
      {{ product.Price }} <span>{{ 'Intellitrailer.Booking.UnConfirmedBooking.PriceInformation' | translate: 'SEK per day' }}</span>
      } @else {
      {{ 'Intellitrailer.Booking.BookingSummary.msgOptedOutIsuranceInfo' | translate: 'You have opted out of the insurance' }}
      }
    </p>

    <div mat-dialog-content>
      @if (haveInsurance) {
      <div class="row">
        <div class="col-3">
          <img src="/../../../../assets/Images/Icon_Trailer_green_round.png" />
        </div>
        <div class="col-9">
          <p> {{ 'Intellitrailer.Booking.InsuranceInformation.trailerGreenInfo' | translate: 'The insurance covers the deductible for the trailer up to 5000 SEK' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <img src="/../../../../assets/Images/Icon_Documents_green_round.png" />
        </div>
        <div class="col-9">
          <p> {{ 'Intellitrailer.Booking.InsuranceInformation.documentsGreenInfo1' | translate: 'The insurance covers all the damages to the trailer except spare parts' }}</p>
        </div>
      </div>

      @if (!bookingConfirmed) {
      <div class="row btn-container" mat-dialog-actions>
        <button mat-button mat-raised-button color="primary" (click)="confirm()" class="take-insurance-button">
          {{ 'Intellitrailer.Booking.BookingSummary.driveWithInsurance' | translate: 'Drive safely with insurance' }}
        </button>
        <div (click)="onNoClick()" class="without-insurance-link">
          {{ 'Intellitrailer.Booking.BookingSummary.continueWithoutInsuranceInfo' | translate: 'I want to continue without insurance' }}
        </div>
      </div>
      }
      } @else {
      <div class="row">
        <div class="col-3">
          <img src="/../../../../assets/Images/Icon_Trailer_red_round.png" />
        </div>
        <div class="col-9">
          <p> {{ 'Intellitrailer.Booking.InsuranceInformation.trailerRedInfo' | translate: 'In the event of damage, you are responsible for the deductible of 5000 SEK' }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <img src="/../../../../assets/Images/Icon_Documents_red_round.png" />
        </div>
        <div class="col-9">
          <p> {{ 'Intellitrailer.Booking.InsuranceInformation.documentsRedInfo' | translate: 'If an accident occurs, you will be responsible for managing the claims process' }}</p>
        </div>
      </div>

      @if (!bookingConfirmed) {
      <div class="row btn-container" mat-dialog-actions>
        <button mat-button mat-raised-button color="primary" (click)="confirm()" class="take-insurance-button">
          {{ 'Intellitrailer.Booking.BookingSummary.addInsuranceButtonText' | translate: 'Add insurance' }} {{ product.Price | currency }}
        </button>
        <div class="without-insurance-link" (click)="onNoInsurance()">
          {{ 'Intellitrailer.Booking.BookingSummary.continueWithoutInsuranceInfo' | translate: 'I want to continue without insurance' }}
        </div>
      </div>
      }
      }
    </div>
  </div>
  } @else {
  <div mat-dialog-content>
    <div class="row alternate-info">
      <p>
        @if(product.Description.startsWith('Turbo.')) { <span>{{ product.Description | translate }}</span> }
        @else{ <span>{{ product.Description }}</span> }
      </p>
      <p>
        {{ 'Intellitrailer.Booking.UnConfirmedBooking.ConfirmAddon' | translate: 'Do you want to continue with' }}
        @if(product.Title.startsWith('Turbo.')) { <span>{{ product.Title | translate: 'Excess reduction' }}</span> }
        @else { <span>{{ product.Title }}</span> }
      </p>
    </div>
  </div>
  @if (!bookingConfirmed) {
  <div mat-dialog-actions class="btn-container">
    <button mat-button mat-raised-button color="primary" (click)="confirm()">
      {{ 'Intellitrailer.Booking.Dialog.FindLocationDialog_' + product.Id + '.Yes' | translate : 'Yes' }}
    </button>
    <button mat-button mat-raised-button color="accent" (click)="onNoClick()">
      {{ 'Intellitrailer.Booking.Dialog.FindLocationDialog_' + product.Id + '.ContinueWithout' | translate : 'Continue without' }}
    </button>
  </div>
  }
  }
  @if(bookingConfirmed) {
  <div mat-dialog-actions class="btn-container">
    <button mat-button mat-raised-button color="primary" class="close-btn" (click)="closeDialog()">
      {{ 'Intellitrailer.Booking.AddonDialog.CloseBtn' | translate : 'Close' }}
    </button>
  </div>
  }
</div>
